import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {extractUUIDFromUrl, imageToBase64} from "../../utils/functions";
import {Incident} from "../../dynamic365/entities/Incident";
import {Note} from "../../dynamic365/entities/Note";
import {useEntityObject} from "../../dynamic365";
import StringMap from "../../dynamic365/entities/StringMap";
import Contact from "../../dynamic365/entities/Contact";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Divider} from "primereact/divider";
import {InputTextarea} from "primereact/inputtextarea";
import OptionTypesDialog from "../../dialogs/OptionTypesDialog";
import DocumentItem from "./document-item";
import {Avatar} from "primereact/avatar";
import * as Iconly from 'react-iconly';
import IncidentItem from "./incident-item";
import Paginator from "../../components/Paginator";
import {useUser} from "../../auth/UserContext";
import Account from "../../dynamic365/entities/Account";

function Header (){
    const navigate = useNavigate();
    return(
        <div className="flex w-full p-3 align-items-center gap-3 border-bottom-1 border-gray-300">
            <i className="pi pi-chevron-right p-2 cursor-pointer" onClick={()=>{navigate('/case')}}/>
            <div className="flex flex-column text-sm">
                <span className="text-sm font-bold">ثبت تیکت (درخواست)</span>
                <span className="text-xs">لطفا درخواست خود را ایجاد کنید</span>
            </div>
        </div>
    )
}

function Create(props) {
    const navigate = useNavigate();
    const incidentEntity = useEntityObject(Incident());
    const noteEntity = useEntityObject(Note());
    const stringMapEntity = useEntityObject(StringMap());
    const [title, setTitle] = useState();
    const [description, setDescription] = useState();
    const [caseType, setCaseType] = useState();
    const [departmentType, setDepartmentType] = useState();
    const [loading, setLoading] = useState(false);
    const hiddenFileInput = useRef();
    const [filename, setFileName] = useState();
    const [documentBody, setDocumentBody] = useState();
    const user = useUser();

    const [caseTypesVisible, setCaseTypesVisible] = useState(false);
    const [departmentsVisible, setDepartmentsVisible] = useState(false);

    const create_ticket=()=>{
        if (title && description && caseType.attributevalue){
            setLoading(true);
            incidentEntity.create({
                body:{
                    title,
                    description,
                    "primarycontactid@odata.bind" : "/contacts($contactId)",
                    caseorigincode:StringMap().caseorigincode.WEB,
                    casetypecode:caseType.attributevalue,
                    kph_department:departmentType.attributevalue
                },
                bind:user.state.userData.account?["customerid", Account(), user.state.userData.account.AccountId]:["customerid", Contact(), user.state.userData.contactid],
                onResult:(result)=>{
                    let incidentId = extractUUIDFromUrl(result.headers.location);
                    noteEntity.create({
                        body:{notetext: description, isdocument:documentBody!==undefined, documentbody:documentBody, filename},
                        bind:["objectid", Incident() , incidentId],
                        onResult:()=>{
                            setLoading(false);
                            navigate(`/case/note/${incidentId}`);
                        }
                    })
                },
            })
        }

    }

    useEffect(()=>{
        stringMapEntity.fetch({
            onResult:({data})=>{
                // console.log(data)
            },
            filters:{attributename:'kph_department', objecttypecode:Incident().typeCode}
        })
    },[])
    return(

        <div className="flex flex-column h-full w-full ">
            {/*Place page header hear...*/}
            <Header/>
            <div className="flex-grow-1 h-1rem flex align-items-center justify-content-center">
                {/*Place page content hear...*/}
                <div className="w-full max-h-full lg:w-6 bg-white border-round-xl shadow-1 flex flex-column justify-content-between align-items-center gap-2 overflow-hidden">
                    <div className="w-full flex-1 overflow-y-auto p-2">
                        <div className="w-full">
                            <span className="text-xs text-gray-500 p-1">عنوان درخواست<span className="text-red-500">*</span></span>
                            <InputText className="w-full bg-gray-100 border-gray-400 border-1 border-round-xl" value={title} onChange={(e)=>{setTitle(e.target.value)}}/>
                        </div>

                        <div className="w-full">
                            <div className="flex justify-content-between align-items-center w-full text-xs text-gray-500 p-1">
                                <span>دپارتمان<span className="text-red-500">*</span></span>
                                <span className="text-xs text-primary flex align-items-center gap-1 cursor-pointer">
                                <i className="pi pi-question-circle text-xs"/>
                                <span>راهنما</span>
                            </span>
                                <OptionTypesDialog visible={departmentsVisible} setVisible={setDepartmentsVisible} title="دپارتمان" onSelect={(e)=>{setDepartmentType(e); setDepartmentsVisible(false)}} entityTypeCode={"incident"} attributeName={'kph_department'}  />
                            </div>
                            <Button className="p-button-text w-full p-button-plain p-button-outlined" onClick={()=>{setDepartmentsVisible(true)}}>
                                <span className="flex-grow-1 text-center pr-3">{departmentType?departmentType['_value@OData.Community.Display.V1.FormattedValue']:"انتخاب کنید"}</span>
                                <i className="pi pi-chevron-down"/>
                            </Button>
                        </div>

                        <div className="w-full">
                            <div className="flex justify-content-between align-items-center w-full text-xs text-gray-500 p-1">
                                <span>نوع درخواست<span className="text-red-500">*</span></span>
                                <span className="text-xs text-primary flex align-items-center gap-1 cursor-pointer">
                            <i className="pi pi-question-circle text-xs"/>
                            <span>راهنما</span>
                        </span>
                                <OptionTypesDialog visible={caseTypesVisible} setVisible={setCaseTypesVisible} title="نوع درخواست" onSelect={(e)=>{setCaseType(e); setCaseTypesVisible(false)}} entityTypeCode={Incident().typeCode} attributeName={Incident().fields.casetypecode}  />
                            </div>
                            <Button className="p-button-text w-full p-button-plain p-button-outlined" onClick={()=>{setCaseTypesVisible(true)}}>
                                <span className="flex-grow-1 text-center pr-3">{caseType?caseType['_value@OData.Community.Display.V1.FormattedValue']:"انتخاب کنید"}</span>
                                <i className="pi pi-chevron-down"/>
                            </Button>
                        </div>

                        <div className="w-full">
                            <span className="text-xs text-gray-500 p-1">شرح موضوع</span>
                            <InputTextarea className="w-full h-8rem bg-gray-100 border-gray-400 border-1 border-round-xl" value={description} onChange={(e)=>{setDescription(e.target.value)}}/>
                        </div>

                        <div className="w-full">
                            <span className="w-full text-xs text-gray-500 p-1">آپلود عکس / فایل</span>
                            <div className="w-full bg-gray-100 hover:bg-gray-200 border-gray-400 border-1 border-round-xl p-2">
                                {documentBody ? (<DocumentItem documentBody={documentBody} filename={filename} setDocumentBody={setDocumentBody} setFileName={setFileName}/>):(<div className="h-10rem flex flex-column justify-content-center align-items-center cursor-pointer" onClick={()=>{hiddenFileInput.current.click();}}><Avatar className="bg-transparent" icon={()=>(<Iconly.Download set="two-tone" primaryColor="#aaa" filled/>)}/><span className="text-xs text-gray-500">محل بارگزاری</span></div>)}
                            </div>
                            <input ref={hiddenFileInput} className="p-hidden" type="file" onChange={(e)=>{const file = e.target.files[0]; setFileName(e.target.files[0] && e.target.files[0].name) ;imageToBase64(file, (b64)=>{setDocumentBody(b64)});}}/>

                        </div>

                    </div>
                    <div className="p-2 w-full">
                        <Button loading={loading} className="w-full border-round-lg" label="ارسال" onClick={()=>{create_ticket()}}/>

                    </div>
                </div>

            </div>
        </div>

    )
}

export default Create;